import { z } from 'zod';

// Folha do módulo (sem imports de `mice*`): `mice.ts` e `mice_participants.ts` dependem dela
// sem fechar ciclo.
export const MiceNamedRefSchema = z.object({ id: z.string().min(1), name: z.string() });
export type MiceNamedRef = z.infer<typeof MiceNamedRefSchema>;

export const IataSchema = z.string().regex(/^[A-Z]{3}$/);

export const HhMmSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const CarrierSchema = z.string().regex(/^[A-Z0-9]{2}$/);
export const FlightNumberSchema = z.string().regex(/^\d{1,4}$/);

export const MiceTripKindSchema = z.enum(['round_trip', 'outbound_only', 'return_only']);
export type MiceTripKind = z.infer<typeof MiceTripKindSchema>;

/** Voo sugerido pela agência na planilha (campos opcionais do que ela informou). Mora na folha
 *  porque `mice_participants` (que `mice` importa) o usa na viagem da planilha de participantes. */
export const MiceSuggestedFlightSchema = z.object({
  carrier: CarrierSchema,
  flightNumber: FlightNumberSchema,
  date: z.iso.date(),
  from: IataSchema.nullable(),
  to: IataSchema.nullable(),
  departTime: HhMmSchema.nullable(),
});
export type MiceSuggestedFlight = z.infer<typeof MiceSuggestedFlightSchema>;

export const MiceMoneySchema = z.object({ amount: z.number(), currency: z.string() });
export type MiceMoney = z.infer<typeof MiceMoneySchema>;

export const NumericIdSchema = z.string().regex(/^\d+$/);

/** O corpo das ações do organizador sem outro dado: confirmar as premissas, encerrar e reabrir
 *  as compras, reabrir as premissas, publicar o evento. */
export const SelfServiceActionRequestSchema = z.object({ organizerId: NumericIdSchema });
export type SelfServiceActionRequest = z.infer<typeof SelfServiceActionRequestSchema>;
